// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200706/js/" + chunkId + "." + {"44":"74061a50","225":"7f94d4ce","481":"635d7e46","486":"ee6b7780","770":"b91abee4"}[chunkId] + ".0.8890879388684316.chunk.js";
};